export var ACTION;
(function (ACTION) {
    ACTION["VALIDATE_FORM"] = "VALIDATE_FORM";
    ACTION["VERIFY_PAN"] = "VERIFY_PAN";
    ACTION["ENABLE_CONTINUE"] = "ENABLE_CONTINUE";
    ACTION["DISABLE_CONTINUE"] = "DISABLE_CONTINUE";
    ACTION["VALIDATE_PAN"] = "VALIDATE_PAN";
    ACTION["VALIDATE_DOB"] = "VALIDATE_DOB";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["CONTINUE"] = "CONTINUE";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["CONFIRM_PAN"] = "CONFIRM_PAN";
    ACTION["CHANGE_PAN_NO"] = "CHANGE_PAN_NO";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["CLOSE_MODAL"] = "CLOSE_MODAL";
    ACTION["ON_CHANGE_TEXT"] = "ON_CHANGE_TEXT";
    ACTION["EDIT_DETAILS_ACTION"] = "EDIT_DETAILS_ACTION";
    ACTION["CLOSE_PAN_MODAL"] = "CLOSE_PAN_MODAL";
})(ACTION || (ACTION = {}));
